import { providers } from '@data-provider/core';

// "http://localhost:3100"
providers.getByTag("axios").config({
  baseUrl: process.env.API_HOST
});
